import { useSelector } from 'react-redux'
import { Bar, BarChart } from 'recharts'
import { ColumnCellWithCollapse } from './ColumnCellWithCollapse'

export const FirstColumnCell = ({
  ids,
  rowId,
  val,
  style,
  selectRowData,
  selectChildIds,
  selectParentIds,
  changeIds,
}) => {
  const rowData = useSelector(selectRowData(rowId))
  const childIds = useSelector(selectChildIds(rowId))
  const parentId = useSelector(selectParentIds(rowId))

  const chartData = Object.keys(rowData)
    .filter((key) => !['childrenIds', 'col1', 'parentId'].includes(key))
    .map((item) => {
      return {
        label: item,
        value: rowData[item]?.value,
      }
    })

  const fieldStyle = rowData.fieldStyle || ''

  return (
    <div className="dFlex justifyContentBetween alignItemsCenter">
      <ColumnCellWithCollapse
        ids={ids}
        rowId={rowId}
        val={val}
        style={style}
        childIds={childIds}
        parentId={parentId}
        changeIds={changeIds}
        fieldStyle={fieldStyle}
      />
      <div>
        <BarChart width={36} height={32} data={chartData} barSize={3}>
          <Bar dataKey="value" fill="#0553A5" />
        </BarChart>
      </div>
    </div>
  )
}
